<template>
  <PageLayout class="products-page">
    <PageTitle class="page-title">Страхові продукти</PageTitle>
    <Breadcrumbs/>
    <InsuranceProducts />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import InsuranceProducts from '../../views/insuranceProducts/Index.vue';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import Breadcrumbs from '@/components/ui/Breadcrumbs';

export default {
  created() {
    this.changeActivePage(pages.PRODUCTS_AND_PROPOSITIONS);
  },
  components: { PageLayout, PageTitle, InsuranceProducts, Breadcrumbs },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>

</style>
